/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * 校验是否是有效联系方式
 * @param contact 联系方式
 * @returns {boolean}
 */
export function validateContact(contact) {
  // 正则表达式用于验证电话号码
  const phoneRegex = /^(((\d{3,4}-)?[0-9]{7,8})|(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8})$/

  // 正则表达式用于验证邮箱地址
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  // 验证是否是有效的手机号或邮箱
  if (phoneRegex.test(contact) || emailRegex.test(contact)) {
    return true
  } else {
    return false
  }
}
